import { styled } from '@material-ui/core/styles';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';

export const SeparatorStyled = styled(ChevronRightRoundedIcon)({
  color: 'rgba(0, 0, 0, 0.35)',
  width: '15px',
  margin: 0,
});
